import React, { FC } from 'react';
import { ToastProps } from './toast.types';
import error from './icons/error.png';
import info from './icons/info.png';
import success from './icons/success.png';
import warning from './icons/warning.png';

import styles from './toast.module.scss';

export const Toast: FC<ToastProps> = props => {
  const { message, type } = props;
  const icons = { error, info, success, warning };

  return (
    <div className={styles.container}>
      <img alt="" className={styles.imageContainer} src={icons[type]} />
      <span>{message}</span>
    </div>
  );
};
